import Navigation from "./Navigation";
import Legal from "./Legal";
import styles from "./Feedback.module.scss";
import { useParams } from "react-router-dom";
import { useTrackPageVisit } from "../hooks/useTrackPageVisit";

const FEEDBACK_HERO_DECOR =
  "https://billcap-cdn.s3.ap-southeast-2.amazonaws.com/Engie/tracker/feedback_hero_background.png";
const FEEDBACK_HERO_FRAME_BG =
  "https://billcap-cdn.s3.ap-southeast-2.amazonaws.com/Engie/tracker/feedback_hero_background_image.png";
const FEEDBACK_HERO_IMAGE =
  "https://billcap-cdn.s3.ap-southeast-2.amazonaws.com/Engie/tracker/feedback_hero_image.png";

export default function Feedback() {
  const { accountId } = useParams();
  useTrackPageVisit("feedback", accountId as string);

  return (
    <div className={styles.feedback}>
      <Navigation />
      <div className={styles.main}>
        <div
          className={styles.mainInner}
          style={{ backgroundImage: `url(${FEEDBACK_HERO_DECOR})` }}
        >
          <section
            className={styles.hero}
            aria-labelledby="feedback-heading"
          >
            <div className={styles.heroText}>
              <h2 id="feedback-heading" className={styles.heroTitle}>
                Help us make Tracker better
              </h2>
              <div className={styles.heroBody}>
                <p>
                  If you&apos;ve got feedback, suggestions, or something
                  doesn&apos;t quite look right, we&apos;d really like to know.
                </p>
                <p>
                  Send us a quick email at{" "}
                  <a
                    href="mailto:ideas.au@engie.com"
                    className={styles.emailLink}
                  >
                    ideas.au@engie.com
                  </a>{" "}
                  and we&apos;ll get back to you shortly.
                </p>
              </div>
            </div>
            <div className={styles.heroArt}>
              <div className={styles.heroArtFrame}>
                <div
                  className={styles.heroArtBg}
                  style={{
                    backgroundImage: `url(${FEEDBACK_HERO_FRAME_BG})`,
                  }}
                  aria-hidden="true"
                />
                <img
                  className={styles.heroArtImg}
                  src={FEEDBACK_HERO_IMAGE}
                  alt=""
                  width={600}
                  height={332}
                  decoding="async"
                />
              </div>
            </div>
          </section>
        </div>
      </div>
      <Legal accountId={accountId} />
    </div>
  );
}
